export const TIME_PERIOD = {
  START: 'start',
  END: 'end'
};

export const TIME_DEFAULT = {
  [TIME_PERIOD.START]: {
    hours: '00',
    minutes: '00'
  },
  [TIME_PERIOD.END]: {
    hours: '00',
    minutes: '00'
  }
};

export const TIME_FOR_EQUAL_DAYS = {
  [TIME_PERIOD.START]: {
    hours: '00',
    minutes: '00'
  },
  [TIME_PERIOD.END]: {
    hours: '24',
    minutes: '00'
  }
};

export const NUMBER_PATTERN = /^[0-9]+$/;

export const MAX_VALUE_LIST = {
  hours: [2, 9],
  minutes: [5, 9]
};
